module.exports = __webpack_public_path__ + "img/Foto_Press_release_DAB_Pak_Hendra.b168801a.jpeg";